import { useEffect, useState } from 'react'
import { Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'
import { ColStack } from 'components/atoms/container/InCardStack'
import EastIcon from '@mui/icons-material/East'
import { JOURNEY } from 'routes/constants'
import {
  getUserCurrentGoal,
  getCurrentL1MilestoneWithCohortSession
} from 'utils/getSupportingInfo'
import { getLocalUser } from 'utils/localStorage'
import { useNavigate } from 'react-router-dom'
import { Tag } from 'components/atoms/Text'
import moment from 'moment'
import { formatDate } from 'utils/formatDateTime'

const JumpToGoalButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const user = getLocalUser()
  const [currentGoal, setCurrentGoal] = useState(null)
  const [currentL1Milestone, setCurrentL1Milestone] = useState(null)
  const [sessionOverdue, setSessionOverdue] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const goal = await getUserCurrentGoal()
      setCurrentGoal(goal)

      if (user?.isCohortUser) {
        const res = await getCurrentL1MilestoneWithCohortSession(goal)
        setCurrentL1Milestone(res?.currentL1Milestone)
        const facilitationDate =
          res?.currentL1Milestone?.cohortSession?.facilitationDate

        const isOverDue = facilitationDate
          ? moment()
              .startOf('day')
              .isAfter(moment(facilitationDate).startOf('day'))
          : false
        setSessionOverdue(isOverDue)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {currentGoal && !currentGoal?.opensAt && (
        <RowStack
          spacing={8}
          sx={{
            borderRadius: 4,
            backgroundColor: colors.MidnightTeal400,
            paddingX: 8,
            paddingY: 4,
            boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.15)',
            width: 'auto',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: colors.MidnightTeal300
            }
          }}
          onClick={() => navigate(JOURNEY)}>
          <ColStack spacing={0}>
            {user?.isCohortUser && sessionOverdue ? (
              <Tag
                variant={'eyebrow'}
                sx={{
                  paddingX: 2,
                  paddingY: 1,
                  border: `1px solid ${colors.Watermelon400}`,
                  backgroundColor: colors.Peach100,
                  fontSize: 10,
                  fontWeight: 700,
                  color: colors.Watermelon400
                }}>
                {t('welcomeArea.overdueClosed')}{' '}
                {formatDate(
                  currentL1Milestone?.cohortSession?.facilitationDate
                )}
              </Tag>
            ) : (
              <Typography
                variant='body1KindaSmall'
                color={colors.White}
                fontWeight={700}>
                {t('welcomeArea.jumpBackInto')}
              </Typography>
            )}
            <Typography variant='body1Small' color={colors.White}>
              {currentGoal?.name}
            </Typography>
          </ColStack>

          <Button endIcon={<EastIcon />} size='small'>
            {t('welcomeArea.go')}
          </Button>
        </RowStack>
      )}
    </>
  )
}

export default JumpToGoalButton
